import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

    {
        Name: "Nayuni Vandana",
        Position: "Ph.D Scholar",
        Batch: "July 2022",
        AreasofResearch: "Novel Membrane Technology",
        GuideName: "Prof. Anki Reddy Katha",
        GuideLink: "/dr-anki-reddy-katha",
        CoGuideName: "Prof. KSMS Raghavarao",
        CoGuideLink: "/dr-ksms-raghavarao",
        Email: "ch22d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/N_Vandana.png"
    },

    {
        Name: "Vinith J",
        Position: "Ph.D Scholar",
        Batch: "July 2022",
        AreasofResearch: "Nano bio technology",
        GuideName: "Dr. Uday Kumar",
        GuideLink: "/dr-s-uday-kumar",
        CoGuideName: "",
        CoGuideLink: "",
        Email: "ch22d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Vinith.jpg"
    },
    {
        Name: "N Sai Prasanna",
        Position: "Ph.D Scholar",
        Batch: "January 2022",
        AreasofResearch: "Membrane Processing for Desalination and other applications.",
        GuideName: "Dr. KSMS Raghavarao",
        GuideLink: "/dr-ksms-raghavarao",
        CoGuideName: "Dr. Nilesh Choudhary",
        CoGuideLink: "/dr-nilesh-choudhary",
        Email: "ch22d001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/prasanna.jpg"
    },
    {
        Name: "Prashant Kumar",
        Position: "Ph.D Scholar",
        Batch: "January 2022",
        AreasofResearch: "Food Engineering & Technology.",
        GuideName: "Dr. Trivikram Reddy Nallamilli",
        GuideLink: "/dr-trivikram-nallamilli",
        Email: "ch22d002@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/prashant.jpg"
    },
    {
        Name: "Satyam Shree",
        Position: "Ph.D Scholar",
        Batch: "January 2022",
        AreasofResearch: "Modeling, Simulation & Experimental work in Membrane based separation process.",
        GuideName: "Prof. Anki Reddy katha",
        GuideLink: "/dr-anki-reddy-katha",
        Email: "ch22d003@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/satyam.jpg"
    },
    {
        Name: "Yumnam Nandan",
        Position: "Ph.D Scholar",
        Batch: "January 2022",
        AreasofResearch: "Osmotic Membrane Processes for desalination and its food applications.",
        GuideName: "Dr. KSMS Raghavarao",
        GuideLink: "/dr-ksms-raghavarao",
        CoGuideName: "Dr. Nilesh Choudhary ",
        CoGuideLink: "/dr-nilesh-choudhary",
        Email: "ch22d004@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Yumnam.jpg"
    },
    {
        Name: "Vivek Gupta",
        Position: "Ph.D Scholar",
        Batch: "July 2021",
        AreasofResearch: "Food Science and Technology.",
        GuideName: "Dr. KSMS Raghavarao",
        GuideLink: "/dr-ksms-raghavarao",
        CoGuideName: "Dr. Trivikram Nallamilli",
        CoGuideLink: "/dr-trivikram-nallamilli",
        Email: "ch21d504@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/VIVEK%20GUPTA.jpg"
    },
    {
        Name: "Mohammad Irfan",
        Position: "Ph.D Scholar",
        Batch: "July 2021",
        AreasofResearch: "Surface & Interfacial Properties of Nanomaterials.",
        GuideName: "Dr. Narendra Singh",
        GuideLink: "/dr-narendra-singh",
        Email: "ch21d505@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Mohammad.jpg"
    },
    {
        Name: "Rahul Sinha",
        Position: "Ph.D Scholar",
        Batch: "July 2021",
        AreasofResearch: "Catalytic reactions and its applications.",
        GuideName: "Dr. Sasidhar Gumma",
        GuideLink: "/dr-sasidhar-gumma",
        CoGuideName: "Dr. Narendra Singh",
        CoGuideLink: "/dr-narendra-singh",
        Email: "ch21d503@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Rahul.jpg"
    },
    {
        Name: "Manjay Kumar",
        Position: "Ph.D Scholar",
        Batch: "July 2021",
        AreasofResearch: "Process Monitoring.",
        GuideName: "Dr. Nabil M",
        GuideLink: "/dr-m-nabil",
        Email: "ch21d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Manjay.jpg"
    },
    {
        Name: "Bakthar Khan Babajan",
        Position: "Ph.D Scholar",
        Batch: "July 2021",
        AreasofResearch: "Modeling, Simulation & Experimental work in Microfluidics.",
        GuideName: "Prof. Thamida Sunil Kumar",
        GuideLink: "/dr-thamida-sunil-kumar",
        CoGuideName: "Dr. Anil Vir",
        CoGuideLink: "/dr-anil-vir",
        Email: "ch21d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Bakthar.jpg"
    },
    {
        Name: "M. Selvakumar",
        Position: "Ph.D Scholar",
        Batch: "January 2021",
        AreasofResearch: "Extraction and purification of bioactives\nEmulsions and encapsulations studies for Food Application.",
        GuideName: "Prof. KSMS Raghavarao",
        GuideLink: "/dr-ksms-raghavarao",
        CoGuideName: "Dr. Trivikram Nallamilli",
        CoGuideLink: "/dr-trivikram-nallamilli",
        Email: "ch21d003@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Selvakumar.jpg"
    },
    {
        Name: "B. Joseph Abhisheka Rao",
        Position: "Ph.D Scholar",
        Batch: "January 2021",
        AreasofResearch: "Multiphase Microfluidics.",
        GuideName: "Dr. Anil Vir",
        GuideLink: "/dr-anil-vir",
        Email: "ch21d002@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Joseph.jpg"
    },
    {
        Name: "Vipin Kumar Sharma",
        Position: "Ph.D Scholar",
        Batch: "January 2021",
        AreasofResearch: "Separation of carbondioxide from the flue gas and its usage in carbonation of process liquor in the mining and mineral processing industry",
        GuideName: "Prof. Thamida Sunil Kumar",
        GuideLink: "/dr-thamida-sunil-kumar",
        CoGuideName: "Dr. B. Naveen Kumar Reddy (External)",
        CoGuideLink: "/dr-b-naveen-kumar-reddy",
        Email: "ch21d005@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/VIPIN%20KUMAR%20SHARMA.JPG"
    },
    {
        Name: "Amarendra Kumar Gupta",
        Position: "Ph.D Scholar",
        Batch: "July 2020",
        AreasofResearch: "Heat Generation through an Air Blower with Recycle: Modelling, Simulation & Experiment.",
        GuideName: "Prof. Thamida Sunil Kumar",
        GuideLink: "/dr-thamida-sunil-kumar",
        Email: "ch20d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/CH20D501.jpg"
    },
    {
        Name: "Chinthalapudi Naga Lakshmi",
        Position: "Ph.D Scholar",
        Batch: "July 2020",
        AreasofResearch: "Synthesis of Nanomaterials for Environmental Applications",
        GuideName: "Dr. Narendra Singh",
        GuideLink: "/dr-narendra-singh",
        Email: "ch20d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/ch20d502.jpg"
    },
    {
        Name: "A. Rahul Yadav",
        Position: "M.S (Research) Scholar",
        Batch: "July 2021",
        AreasofResearch: "Reinforcement Learning For Process Systems",
        GuideName: "Dr. M. Nabil (CH)",
        GuideLink: "/dr-m-nabil",
        CoGuideName: "Dr. Ajin George Joseph (CSE)",
        CoGuideLink: "/dr-ajin-george-joseph",
        Email: "ch21s501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Rahul%20Yadav.jpg"
    },
    {
        Name: "Vaishali Saraswat",
        Position: "M.S (Research) Scholar",
        Batch: "July 2021",
        AreasofResearch: "Food Science and Technology",
        GuideName: "Prof. KSMS Raghavarao",
        GuideLink: "/dr-ksms-raghavarao",
        CoGuideName: "Dr. Trivikram Nallamilli",
        CoGuideLink: "/dr-trivikram-nallamilli",
        Email: "ch21s502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Vaishali.jpg"
    },
    {
        Name: "Arjun M",
        Position: "M.S (Research) Scholar",
        Batch: "January 2020",
        AreasofResearch: "Machine learning for process systems",
        GuideName: "Dr. M Nabil",
        GuideLink: "/dr-m-nabil",
        Email: "ch20s001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/ch/Arjun.jpg"
    }
]



function Main() {

    return (
        <>

            <Header />
            <Breadcrumb title="Home"  subtitle="Chemical Engineering" />

        
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Chemical Engineering</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
       

                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>
                                       
                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasofResearch}</p>
                                            
                                            {/* Parse the HTML content and extract text */}
                                            
                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank"> {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}

                                            

                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>                                       
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main